import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCroquisImageIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#FEF3E9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.2031 29.543H23.2031C28.2031 29.543 30.2031 27.543 30.2031 22.543V16.543C30.2031 11.543 28.2031 9.54297 23.2031 9.54297H17.2031C12.2031 9.54297 10.2031 11.543 10.2031 16.543V22.543C10.2031 27.543 12.2031 29.543 17.2031 29.543Z",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7016 24.6211H23.8516",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1731 24.6211H14.7031",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7019 20.8633H20.1719",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4731 20.8633H14.7031",
			stroke: "#FC8210",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCroquisImageIcon;
